import React from 'react';
import { Flower2 } from 'lucide-react';
import { cn } from '@/lib/utils';
import { MEMORIAL_COPY, isPublicTributeEnabled, formatPersonDates } from '../../utils/memorial';

/**
 * Softer memorial presentation on person overview when Memorial Mode is on.
 */
export function MemorialProfileBanner({ person, className, onManageTribute }) {
  if (!person?.memorial_summary?.memorial_active && !(person?.life_state === 'remembered' && person?.memorial_mode_enabled)) {
    return null;
  }

  const name = [person.given_names, person.surname].filter(Boolean).join(' ');
  const line = person.remembrance_line || person.memorial_summary?.remembrance_line;
  const years = formatPersonDates(person);
  const publicOn = isPublicTributeEnabled(person);

  return (
    <section
      className={cn(
        'rounded-2xl border border-[hsl(38_14%_88%)]/60 bg-gradient-to-br from-[hsl(42_30%_99%)] to-[hsl(38_18%_94%)]/80 px-5 py-5 sm:px-6 sm:py-6',
        className
      )}
      data-testid="memorial-profile-banner"
      aria-label={`${MEMORIAL_COPY.rememberedHere} — ${name}`}
    >
      <div className="flex items-start gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-[hsl(38_14%_86%)] bg-[hsl(42_28%_99%)]">
          <Flower2 className="h-5 w-5 text-[hsl(38_36%_42%)]/80" strokeWidth={1.25} aria-hidden />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-[10px] font-semibold uppercase tracking-[0.16em] text-[hsl(32_10%_42%)]">
            {MEMORIAL_COPY.rememberedHere}
          </p>
          <p className="mt-1 font-serif text-lg text-[hsl(24_14%_18%)]">{name}</p>
          {years ? <p className="mt-0.5 text-sm tabular-nums text-muted-foreground">{years}</p> : null}
          {line ? (
            <p className="mt-3 font-serif text-sm italic leading-relaxed text-[hsl(32_10%_38%)]">&ldquo;{line}&rdquo;</p>
          ) : null}
          <p className="mt-3 text-xs leading-relaxed text-muted-foreground">
            {MEMORIAL_COPY.memorialMode} — stories, voice, and documents stay preserved in your family archive.
            {publicOn ? ' A tribute page is available to visitors you share it with.' : ' Tribute page is private until you choose to share it.'}
          </p>
          {onManageTribute ? (
            <button
              type="button"
              onClick={onManageTribute}
              className="mt-3 text-xs font-medium text-[#8B7355] underline-offset-4 hover:underline"
            >
              {MEMORIAL_COPY.configureVisibility}
            </button>
          ) : null}
        </div>
      </div>
    </section>
  );
}

export default MemorialProfileBanner;
